import {
  Monitor,
  GraduationCap,
  Radio,
  ClipboardCheck,
  Handshake,
  Users,
  BarChart3,
  Compass,
} from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { NeonButton } from "@/components/Buttons";
import { scrollToId } from "@/lib/ui";

const ITEMS = [
  { icon: Monitor, title: "P.E.E. OS ACCESS", desc: "Full access to the execution operating system." },
  { icon: GraduationCap, title: "EXECUTOR TRAINING", desc: "A structured curriculum built on the P.E.E. framework." },
  { icon: Radio, title: "LIVE COACHING", desc: "Scheduled live sessions focused on execution." },
  { icon: ClipboardCheck, title: "TRADE REVIEW", desc: "Break down decisions against your process." },
  { icon: Handshake, title: "ACCOUNTABILITY", desc: "Check-ins that keep discipline measurable." },
  { icon: Users, title: "PRIVATE COMMUNITY", desc: "A focused network of execution-driven traders." },
  { icon: BarChart3, title: "P.E.E. ANALYTICS", desc: "Your execution data, measured over time." },
  { icon: Compass, title: "EXECUTOR DEVELOPMENT", desc: "Milestones that track who you are becoming." },
];

export default function Community() {
  return (
    <section id="community" data-testid="community-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <span id="training" className="block h-0" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="08 — Community"
          testid="community-heading"
          title={
            <>
              Execution is a skill.
              <br />
              We build <span className="glow-text-neon text-neon">Executors.</span>
            </>
          }
          description="Execution Traders Community combines P.E.E. OS technology, Executor Training, accountability, education, trade review, and a community focused on developing disciplined traders."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((c, i) => (
            <Reveal key={c.title} delay={0.05 * i} className="h-full">
              <div
                data-testid={`community-card-${i}`}
                className="group h-full rounded-lg border border-line bg-charcoal p-6 transition-colors duration-500 hover:border-neon/45"
              >
                <c.icon size={18} className="text-neon" />
                <h3 className="mt-4 font-mono text-xs font-semibold uppercase tracking-[0.16em] text-white">
                  {c.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-mist">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 text-center">
            <NeonButton testid="community-join-button" onClick={() => scrollToId("pricing")}>
              Join Execution Traders
            </NeonButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
